import { isMockMode, postId, simulateDelay } from "../api";

export const getAllUsersAdmin = (query) => {
	if (isMockMode()) {
		const testData = {
			totalAvailable: 1,
			fetchedCount: 1,
			paginationMetadata: {
				pageNo: 1,
				pageSize: 20,
				totalPages: 1,
			},
			skippedCount: 0,
			results: [
				{
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "string",
					lastName: "string",
					isDeleted: false,
					lastUpdatedDateUtc: "2025-12-04T06:33:58.094Z",
					roles: ["string"],
					providerName: "azure",
					allowProviderChanges: true,
				},
			],
		};

		return simulateDelay(50, () => testData);
	}

	return postId("dev/queryusers", query);
};
